

/**
 * 
 * @param {*} data {subject: string, toEmail: string, text: string }
 */
export const postingEmail = async(data, result=()=>{}) => {
  const response = await fetch('/api/emailApi',{
    method:'post',
    body: JSON.stringify(data),
    headers: {
        'Content.Type' : 'application/json'
    }
  })
  const dataResponse = await response.json()
  console.log("nodeemailDataResponse",dataResponse)
  result(dataResponse)
}

export const postingPec = async(data, result=()=>{}) => {
  const response = await fetch('/api/peclApi',{
    method:'post',
    body: JSON.stringify(data),
    headers: {
        'Content.Type' : 'application/json'
    }
  })
  const dataResponse = await response.json()
  console.log("nodeemailDataResponse",dataResponse)
  result(dataResponse)
}

